// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"341":"c060a639","828":"0f8bb617"}[chunkId] + ".css";
};